import React from 'react';

interface HomeWorkIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const HomeWorkIcon: React.FC<HomeWorkIconProps> = ({
  color = '#0098D9',
  ...props
}) => {
  return (
    <svg
      width="36"
      height="29"
      viewBox="0 0 36 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.0417 8.54203H29.3813V6.20245H27.0417V8.54203ZM27.0417 15.5387H29.3813V13.1991H27.0417V15.5387ZM27.0417 22.51H29.3813V20.1704H27.0417V22.51ZM24.3075 28.6029V26.7116H33.6087V2.16078H17.0383V6.85912L15.1475 5.54203V0.269531H35.5V28.6029H24.3075ZM0.5 28.6029V13.4908L11.0546 5.95245L21.5833 13.4854V28.6029H13.3429V20.6604H8.76583V28.6029H0.5ZM2.39125 26.7116H6.875V18.7695H15.2337V26.7116H19.6925V14.462L11.0546 8.31453L2.39125 14.4837V26.7116Z"
        fill={color}
      />
    </svg>
  );
};

export default HomeWorkIcon;
